import React from 'react';

const Loader = () => {
    return (
        <div style={styles.container}>
            <img
                src="https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExbTB3YnBsaXlsdHhnOHB1ZnJ0MGswbDRoN3R2ZW94aTUyM2RxeXdibiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/xT3i1jSEzp4yrbF0Lm/giphy.gif"
                alt="Loading..."
                style={styles.image}
            />
            <p style={styles.text}>Processing your request...</p>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
    },
    image: {
        width: '200px',
        height: '200px',
    },
    text: {
        marginTop: '10px',
        fontSize: '16px',
    },
};

export default Loader;
